import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import yn from 'yn'
import { ToggleFeature, features } from 'features/ToggleFeature'

export default class Form extends Component {
  constructor (props) {
    super(props)
    this.state = {
      addressType: 'Residencial',
      zipCode: this.props.address.zipCode || '',
      street: this.props.address.street || '',
      number: this.props.address.number || '',
      complement: this.props.address.complement || '',
      city: this.props.address.city || '',
      state: this.props.address.state || '',
      validators: {
        addressType: true,
        zipCode: true,
        street: true,
        number: true,
        complement: true,
        city: true,
        state: true
      }
    }

    this.save = this.save.bind(this)
    this.validate = this.validate.bind(this)
    this.handleField = this.handleField.bind(this)
  }

  validate () {
    let nextState = { ...this.state }
    nextState.validators.zipCode = !!this.state.zipCode
    nextState.validators.street = !!this.state.street
    nextState.validators.number = !!this.state.number
    nextState.validators.city = !!this.state.city
    nextState.validators.state = !!this.state.state
    this.setState({ nextState })

    return (
      nextState.validators.zipCode &&
      nextState.validators.street &&
      nextState.validators.number &&
      nextState.validators.city &&
      nextState.validators.state
    )
  }

  save () {
    if (this.validate()) {
      this.props.handleAddress({ ...this.state })
      this.props.handleStep(2)
    }
  }

  handleField (value, field) {
    this.setState({
      [field]: value,
      validators: { ...this.state.validators, [field]: !!value }
    })
  }

  render () {
    return (
      <Fragment>
        <div className='d-flex flex-column flex-wrap flex-md-row bg-ui-4 border-color-ui-3 border-bottom p-2'>
          <div className='col-12 col-md-6 p-0'>
            <div className='d-flex align-items-center'>
              <Input
                id='zipCode'
                label='CEP'
                className='col-12 mr-2 p-0 my-1'
                disabled={yn(this.props.address.zipCodeDisabled)}
                onChange={e => this.handleField(e.target.value, 'zipCode')}
                value={this.state.zipCode}
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                valid={this.state.validators.zipCode}
              />
            </div>
            <div className='d-flex align-items-center'>
              <Input
                id='address'
                label='Endereço'
                className='col-12 p-0 my-1'
                onChange={e => this.handleField(e.target.value, 'street')}
                value={this.state.street}
                disabled={yn(this.props.address.streetDisabled)}
                valid={this.state.validators.street}
              />
            </div>
            <div className='d-flex justify-content-between'>
              <Input
                id='number'
                label='Número'
                className='col-4 p-0 my-1'
                value={this.state.number}
                onChange={e => this.handleField(e.target.value, 'number')}
                disabled={yn(this.props.address.numberDisabled)}
                valid={this.state.validators.number}
              />
              <Input
                id='complement'
                label='Complemento'
                className='col-7 p-0 my-1'
                value={this.state.complement}
                onChange={e => this.handleField(e.target.value, 'complement')}
                disabled={yn(this.props.address.complementDisabled)}
                valid={this.state.validators.complement}
              />
            </div>
            <div className='d-flex align-items-center'>
              <Input
                id='city'
                label='Cidade'
                className='col-12 p-0 my-1'
                value={this.state.city}
                onChange={e => this.handleField(e.target.value, 'city')}
                disabled={yn(this.props.address.cityDisabled)}
                valid={this.state.validators.city}
              />
            </div>
            <div className='d-flex align-items-center'>
              <Input
                id='state'
                label='Estado'
                className='col-12 p-0 my-1'
                value={this.state.state}
                onChange={e => this.handleField(e.target.value, 'state')}
                disabled={yn(this.props.address.stateDisabled)}
                valid={this.state.validators.state}
              />
            </div>
            <div className='d-flex align-items-center mt-2'>
              <Button
                id='save'
                className='btn btn-featured btn-icon txt-button txt-font-body'
                role='button'
                text='Próximo'
                onClick={this.save}
                disabled={this.props && this.props.cardTaxes && !this.props.cardTaxes.success}
              />
            </div>
          </div>
          <ToggleFeature feature={features.LikePlusDeliveryDetail} />
        </div>
      </Fragment>
    )
  }
}

Form.propTypes = {
  address: PropTypes.object,
  handleAddress: PropTypes.func,
  handleStep: PropTypes.func,
  cardTaxes: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Address/Form.js